import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ROWS = [
  { feature: 'Learning Approach', traditional: 'One-size-fits-all', rudvan: '100% Personalized' },
  { feature: 'Question Selection', traditional: 'Fixed difficulty', rudvan: 'Adaptive in real-time' },
  { feature: 'Performance Tracking', traditional: 'Manual & limited', rudvan: 'AI-powered detailed analytics' },
  { feature: 'Study Plan', traditional: 'Manual scheduling', rudvan: 'AI-optimized auto schedule' },
  { feature: 'Practice Material', traditional: 'Finite & repetitive', rudvan: 'Unlimited AI-generated' },
  { feature: 'Doubt Solving', traditional: 'Teacher dependent', rudvan: '24/7 Lexa AI Tutor' },
  { feature: 'Weak Area Focus', traditional: 'Student decides', rudvan: 'AI-detected & curated' },
];

function ComparisonRow({ feature, traditional, rudvan, isDarkTheme }) {
  const border = isDarkTheme ? 'border-white/10' : 'border-gray-200';
  const hoverBg = isDarkTheme ? 'hover:bg-white/5' : 'hover:bg-surface-light';
  const textColor = isDarkTheme ? 'text-white' : 'text-navy';
  const textMuted = isDarkTheme ? 'text-white/60' : 'text-text-slate';

  return (
    <tr className={`${border} border-b ${hoverBg} transition-colors`}>
      <td className={`px-6 py-4 ${textColor} font-medium text-left`}>{feature}</td>
      <td className={`px-6 py-4 ${textMuted} text-center`}>
        <span className="inline-flex items-center gap-2">
          <span className="text-red-400">✕</span> {traditional}
        </span>
      </td>
      <td className="px-6 py-4 text-center">
        <span className="inline-flex items-center gap-2">
          <CheckCircle2 className="text-brand-blue" size={18} />
          <span className={textColor}>{rudvan}</span>
        </span>
      </td>
    </tr>
  );
}

export default function ComparisonSection({ isDarkTheme }) {
  const textColor = isDarkTheme ? 'text-white' : 'text-navy';
  const textMuted = isDarkTheme ? 'text-white/70' : 'text-text-slate';
  const tableBorder = isDarkTheme ? 'border-white/10 bg-white/5' : 'border-gray-200 bg-white';
  const headBg = isDarkTheme ? 'border-white/10 bg-white/5' : 'border-gray-200 bg-surface-light';

  return (
    <section id="comparison" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center mb-16">
        <h2 className={`font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4 ${textColor}`}>
          Why Choose
          <span className="block bg-brand-gradient bg-clip-text text-transparent">RUDVAN</span>
        </h2>
        <p className={`text-lg md:text-xl ${textMuted}`}>See how we differ from traditional learning</p>
      </div>

      <div className={`overflow-x-auto rounded-card border ${tableBorder} backdrop-blur-xl`}>
        <table className="w-full">
          <thead>
            <tr className={`border-b ${headBg}`}>
              <th className={`px-6 py-4 text-left ${textColor} font-bold whitespace-nowrap`}>Feature</th>
              <th className={`px-6 py-4 text-center ${textMuted} font-bold whitespace-nowrap`}>Traditional Learning</th>
              <th className="px-6 py-4 text-center text-brand-blue font-bold whitespace-nowrap">RUDVAN</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <ComparisonRow key={row.feature} isDarkTheme={isDarkTheme} {...row} />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
